import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "41",
  fill: "none",
  viewBox: "0 0 40 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#DEDFFF",
  d: "M12.422 28.047c-1.094-.625-1.328-2.344-2.188-3.281-.312-.235-.703-.47-1.093-.703l-4.063 9.843c-.234.625-.156 1.328.313 1.875s1.172.782 1.797.625l3.515-.703 1.719 3.281A1.82 1.82 0 0 0 14.062 40h.079c.78 0 1.406-.469 1.64-1.094l3.75-8.984c-1.093-.235-2.11-1.25-3.125-1.563-1.25-.312-2.89.313-3.984-.312m22.422 5.86-4.063-9.844c-.39.234-.781.468-1.093.703-.86.937-1.094 2.656-2.188 3.28-1.094.626-2.734 0-3.984.313-1.016.313-2.032 1.328-3.047 1.563l3.672 8.984c.234.625.859 1.094 1.64 1.172 0-.078 0-.078.078-.078.703 0 1.328-.312 1.641-1.016l1.719-3.28 3.515.702c.625.157 1.328-.078 1.797-.625s.547-1.25.313-1.875"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#7478E6",
  d: "M34.922 15c0-1.25-1.406-2.344-1.719-3.516-.312-1.25.313-2.89-.312-3.984s-2.344-1.328-3.203-2.187c-.938-.938-1.172-2.657-2.266-3.282s-2.735 0-3.985-.312C22.345 1.406 21.25 0 20 0c-1.328 0-2.422 1.406-3.594 1.719-1.25.312-2.89-.313-3.984.312-1.016.625-1.328 2.344-2.188 3.282-.937.859-2.656 1.093-3.28 2.187-.626 1.094 0 2.734-.313 3.984C6.328 12.656 5 13.75 5 15c0 1.328 1.328 2.422 1.64 3.594.313 1.25-.312 2.89.313 3.984.625 1.016 2.344 1.328 3.281 2.188.86.937 1.094 2.656 2.188 3.28 1.094.626 2.734 0 3.984.313C17.578 28.672 18.672 30 20 30c1.25 0 2.344-1.328 3.516-1.64 1.25-.313 2.89.312 3.984-.313s1.328-2.344 2.188-3.281c.937-.86 2.656-1.094 3.28-2.188.626-1.094 0-2.734.313-3.984.313-1.172 1.64-2.266 1.64-3.594M20 21.25c-3.516 0-6.25-2.734-6.25-6.25A6.22 6.22 0 0 1 20 8.75c3.438 0 6.25 2.813 6.25 6.25A6.22 6.22 0 0 1 20 21.25"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }